import Lists from "../Backlink/src/Lists/Lists";
import Links from "../Backlink/src/Links/Links";
import Billing from "../Backlink/src/Billing/Billing";
import AddList from "../Backlink/src/Lists/AddList/AddList";
import AddLinks from "../Backlink/src/Links/AddLinks/AddLinks";
import Contact from "../Backlink/src/Common/Contact";
import Faq from "../Backlink/src/Common/Faq";
import CouponCode from "../Backlink/src/CouponCode/CouponCode";
import Dashboard from "../Backlink/src/Dashboard/Dashboard";
import ManageTeam from "../Backlink/src/ManageTeam/ManageTeam";
import Domain from "../Backlink/src/Domain/Domain";
import AddApiKeys from "../Backlink/src/ApiKeys/AddApiKeys.jsx";
import FetchNewBacklink from "../Backlink/src/fetchNewBacklinks/FetchNewBacklink";
import AcceptInvite from "../Backlink/src/AcceptInvite/AcceptInvite";
import Branding from "../Backlink/src/Branding/Branding";
import Pricing from "../Backlink/src/Pricing/Pricing";
import IndexMeNow from "../Backlink/src/IndexMeNow/IndexMeNow";
import AuthenticationIndexMeNow from "../Backlink/src/IndexMeNow/AuthenticationIndexMeNow.jsx";
import ActivityLogs from "../Backlink/src/ActivityLogs/ActivityLogs.jsx";
import LinksActivity from "../Backlink/src/ActivityLogs/LinksActivity.jsx";

export const ROUTES2 = [
  {
    name: "Domain",
    path: "/backlink/domain",
    component: <Domain />,
    isPrivate: true,
  },
  {
    name: "link-without-list",
    path: "/backlink/link",
    component: <Links />,
    isPrivate: false,
  },
  {
    name: "link-for-list",
    path: "/backlink/link/:listId",
    component: <Links />,
    isPrivate: false,
  },
  {
    name: "link",
    path: "/backlink/link/add",
    component: <AddLinks />,
    isPrivate: false,
  },
  {
    name: "link",
    path: "/backlink/link/add/:listId",
    component: <AddLinks />,
    isPrivate: false,
  },
  {
    name: "list-without-listName",
    path: "/backlink/list",
    component: <Lists />,
    isPrivate: false,
  },
  {
    name: "list-for-listName",
    path: "/backlink/list/:listName",
    component: <Lists />,
    isPrivate: false,
  },
  {
    name: "list",
    path: "/backlink/list/add",
    component: <AddList />,
    isPrivate: false,
  },
  {
    name: "IndexMeNow",
    path: "/backlink/index-me-now",
    component: <IndexMeNow />,
    isPrivate: false,
  },
  {
    name: "Activity Logs",
    path: "/backlink/activity-logs",
    component: <ActivityLogs />,
    isPrivate: false,
  },
  {
    name: "Link Activity",
    path: "/backlink/links-activity",
    component: <LinksActivity />,
    isPrivate: false,
  },
  {
    name: "pricing",
    path: "/backlink/pricing",
    component: <Pricing />,
    isPrivate: false,
  },
  {
    name: "upgrade",
    path: "/backlink/upgrade",
    component: <CouponCode />,
    isPrivate: false,
  },
  {
    name: "manage-team",
    path: "/backlink/manage-team",
    component: <ManageTeam />,
    isPrivate: false,
  },

  {
    name: "branding",
    path: "/backlink/branding",
    component: <Branding />,
    isPrivate: false,
  },
  {
    name: "acceptInvite",
    path: "/backlink/accept-invitation/:workspaceId",
    component: <AcceptInvite />,
    isPrivate: false,
  },
  {
    name: "billing",
    path: "/backlink/billing",
    component: <Billing />,
    isPrivate: false,
  },
  {
    name: "faq",
    path: "/backlink/faq",
    component: <Faq />,
    isPrivate: false,
  },
  {
    name: "dashboard",
    path: "/backlink/dashboard",
    component: <Dashboard />,
    isPrivate: false,
  },
  {
    name: "contact",
    path: "/backlink/contact-support",
    component: <Contact />,
    isPrivate: false,
  },
  {
    name: "userApiKeys",
    path: "/backlink/user-api-keys",
    component: <AddApiKeys />,
    isPrivate: false,
  },
  {
    name: "fetchBacklinks",
    path: "/backlink/fetch-backlinks",
    component: <FetchNewBacklink />,
  },
  {
    name: "fetchBacklinks",
    path: "/backlink/fetch-backlinks/:id",
    component: <FetchNewBacklink />,
  },
];
